if (!window.customElements.get("component-tabs")) {

    class ComponentTabs extends HTMLElement {

        constructor() {
            super()

            this.tabTitles = this.querySelectorAll('tab-title');
            this.tabContents = this.querySelectorAll('tab-content');
            this.tabAdditionalContent = this.querySelectorAll('tab-additional-content');

        }

        connectedCallback() {

            if (this.tabTitles.length === 0 || this.tabContents.length === 0) {
                return
            }

            this.activateTab(0)
            this.setupEventListeners()
        }

        setupEventListeners() {
            this.tabTitles.forEach((title, index) => {
                title.addEventListener("click", () => this.activateTab(index))
            })
        }

        activateTab(index) {
            this.tabTitles.forEach((title, i) => {
                const isActive = i === index
                title.classList.toggle("active", isActive)
                title.setAttribute("aria-selected", isActive)
            })

            this.tabContents.forEach((content, i) => {
                const isActive = i === index
                content.classList.toggle("active", isActive)
                content.setAttribute("aria-hidden", !isActive)
            });

            this.tabAdditionalContent.forEach((additional, i) => {
                const isActive = i === index
                additional.classList.toggle("active", isActive)
            })
        }
    }

    customElements.define("component-tabs", ComponentTabs)
}
